<script lang="ts">
import { page } from "$app/state";
import { chromeOf } from "$lib/i18n/copy/chrome";
import { splitLocale } from "$lib/i18n/locales";
import { localizeHref } from "$lib/i18n/registry";
import CountryLinks from "./CountryLinks.svelte";
import { DOCS_URL } from "./site";

// The labels come from the page's language, and each link goes to the
// translated version of its page where one exists — the English page
// otherwise. On an English page both are exactly what they always were.
const footer = $derived(chromeOf(page.data).footer);
const locale = $derived(splitLocale(page.url.pathname).locale);
const href = (path: string): string => localizeHref(path, locale);
</script>

<footer class="border-t border-slate-200 bg-white">
  <div class="mx-auto grid max-w-6xl gap-8 px-6 py-12 text-sm sm:grid-cols-2 lg:grid-cols-5">
    <nav aria-label={footer.freeTools}>
      <h2 class="font-semibold text-slate-900">{footer.freeTools}</h2>
      <ul class="mt-3 space-y-2 text-slate-600">
        <li><a href={href("/mrz-checker")} class="hover:text-slate-900">{footer.mrzParser}</a></li>
        <li><a href={href("/mrz-generator")} class="hover:text-slate-900">{footer.mrzGenerator}</a></li>
        <li><a href={href("/document-field-explorer")} class="hover:text-slate-900">{footer.fieldExplorer}</a></li>
      </ul>
    </nav>
    <nav aria-label={footer.guides}>
      <h2 class="font-semibold text-slate-900">{footer.guides}</h2>
      <ul class="mt-3 space-y-2 text-slate-600">
        <li><a href={href("/free-passport-ocr-api")} class="hover:text-slate-900">{footer.freeApi}</a></li>
        <li><a href={href("/mrz-formats")} class="hover:text-slate-900">{footer.mrzFormats}</a></li>
        <li><a href={href("/mcp")} class="hover:text-slate-900">{footer.mcpServer}</a></li>
        <li><a href={href("/compare")} class="hover:text-slate-900">{footer.compare}</a></li>
        <li><a href={href("/passport-ocr")} class="hover:text-slate-900">{footer.byCountry}</a></li>
        <li><a href={href("/blog")} class="hover:text-slate-900">{footer.blog}</a></li>
        <li><a href={DOCS_URL} rel="external" class="hover:text-slate-900">{footer.documentation}</a></li>
        <li><a href={href("/pricing")} class="hover:text-slate-900">{footer.pricing}</a></li>
        <li><a href={href("/status")} class="hover:text-slate-900">{footer.status}</a></li>
      </ul>
    </nav>
    <nav aria-label={footer.byCountry}>
      <h2 class="font-semibold text-slate-900">
        <a href={href("/passport-ocr")} class="hover:text-slate-700">{footer.byCountry}</a>
      </h2>
      <CountryLinks listClass="mt-3 space-y-2 text-slate-600" linkClass="hover:text-slate-900" />
    </nav>
    <nav aria-label={footer.company}>
      <h2 class="font-semibold text-slate-900">{footer.company}</h2>
      <ul class="mt-3 space-y-2 text-slate-600">
        <li><a href={href("/about")} class="hover:text-slate-900">{footer.about}</a></li>
        <li><a href={href("/contact")} class="hover:text-slate-900">{footer.contact}</a></li>
      </ul>
    </nav>
    <nav aria-label={footer.account}>
      <h2 class="font-semibold text-slate-900">{footer.account}</h2>
      <ul class="mt-3 space-y-2 text-slate-600">
        <li><a href={href("/login")} class="hover:text-slate-900">{footer.signIn}</a></li>
        <li><a href={href("/register")} class="hover:text-slate-900">{footer.createAccount}</a></li>
        <li><a href={href("/#demo")} class="hover:text-slate-900">{footer.liveDemo}</a></li>
      </ul>
    </nav>
  </div>
</footer>
